import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule, TranslateService } from '@ngx-translate/core'; // + TranslateService
import { registerLibTranslations } from 'core'; // + helper
import { PlantManagementRoutingModule } from './plant-management-routing.module';
import { PlantManagementLayoutComponent } from './layout/plant-management.layout';
import { ActionBarPortalDirectiveModule } from 'core';
import { ArkikWebComponentsModule } from 'core';
import { PLANXGO_TRANSLATIONS } from '../i18n/planxgo.translations'; // + translations

@NgModule({
  declarations: [PlantManagementLayoutComponent],
  imports: [
    CommonModule,
    PlantManagementRoutingModule,
    ActionBarPortalDirectiveModule,
    ArkikWebComponentsModule,
    TranslateModule.forChild(),
  ],
  providers: [],
})
export class PlantManagementModule {
  constructor(translate: TranslateService) {
    registerLibTranslations(translate, PLANXGO_TRANSLATIONS);
  }
}
